// Generated by apps/nnb-nextjs/scripts/split-tossface-font.py — do not edit.
export const TOSSFACE_CSS_PATH = '/assets/fonts/tossface/tossface.a58a4350.css';
